import React, { useState, useEffect } from "react";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/header";

interface DashboardLayoutProps {
  children: React.ReactNode;
  className?: string;
}


const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children, className = "" }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const toggleSidebar = () => {
    setSidebarExpanded(prev => !prev);
  };

  return (
    <div className="h-screen bg-[#F8FAFB] flex relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] -mr-64 -mt-64 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-primary/3 rounded-full blur-[80px] -ml-32 -mb-32 pointer-events-none"></div>

      <Sidebar expanded={sidebarExpanded} onToggle={toggleSidebar} />
      <Header sidebarExpanded={sidebarExpanded} hasSidebar={true} onToggleSidebar={toggleSidebar} />
      <main className={`flex-1 min-w-0 h-full overflow-y-auto pt-[70px] lg:pt-[80px] pb-10 px-4 md:px-8 transition-all duration-300 ease-in-out relative z-10 no-scrollbar ${sidebarExpanded ? 'lg:ml-80' : 'lg:ml-20'} ${className}`}>
        <div className="max-w-[1800px] mx-auto w-full" style={{ zoom: 0.85 }}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;